"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalConfigOverrideCookie = void 0;
const tslib_1 = require("tslib");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const mapValues_1 = tslib_1.__importDefault(require("lodash/mapValues"));
/**
 * Get the globalConfigOverride cookie from the server side req object.
 *
 * @param {object} req
 * @returns {object} - config object
 */
const getGlobalConfigOverrideCookie = (req) => {
    const cookies = req.cookies;
    const overrideCookie = (0, get_1.default)(cookies, 'globalConfigOverride');
    const overrideObject = overrideCookie ? JSON.parse(overrideCookie) : {};
    return (0, mapValues_1.default)(overrideObject, (val) => Number(val));
};
exports.getGlobalConfigOverrideCookie = getGlobalConfigOverrideCookie;
exports.default = exports.getGlobalConfigOverrideCookie;
//# sourceMappingURL=getGlobalConfigOverrideCookie.js.map